import { getToken, main_url } from "../../../utilis/Common";

export const OCR_API_BASE = `${main_url().replace(/\/+$/, "")}/api/v1`;
const TEXT_TIMEOUT_MS = 10 * 60 * 1000;

/**
 * @param {Blob} imageBlob
 * @param {string} endpoint
 * @param {number} timeoutMs
 * @returns {Promise<Response>}
 */
export const postOcrImage = async (imageBlob, endpoint, timeoutMs) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), timeoutMs);

  const form = new FormData();
  form.append("file", imageBlob, "page.png");

  const headers = {};
  const token = getToken();
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  try {
    return await fetch(`${OCR_API_BASE}${endpoint}`, {
      method: "POST",
      body: form,
      headers,
      signal: controller.signal,
    });
  } finally {
    clearTimeout(timer);
  }
};

/**
 * @param {Blob} imageBlob
 * @returns {Promise<{ success: boolean, lines: Array, error?: string }>}
 */
export async function extractGeneralText(imageBlob) {
  let response;
  try {
    response = await postOcrImage(imageBlob, "/ocr/extract-text", TEXT_TIMEOUT_MS);
  } catch (err) {
    throw new Error(
      `Could not reach OCR service at ${OCR_API_BASE} (${
        err instanceof Error ? err.message : String(err)
      })`,
    );
  }

  if (!response.ok) {
    const body = await response.text().catch(() => "");
    throw new Error(`OCR service returned ${response.status}: ${body}`);
  }

  return response.json();
}
